export function spinner(_ctx) {
    return {
        styles: {
            // background arc (main) line = arc_bg
            main:      { bg_color: '#000000', bg_opa: 0, border_width: 0, border_color: 'black', radius: 0, line_color: '#333333', line_width: 15 },
            // indicator arc = arc_indic
            indicator: { line_color: '#ffffff', line_rounded: true },
        },
    };
}
